import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import LotusLogo from "./LotusLogo";

const Footer = () => (
  <footer className="bg-forest-950 text-cream-50/80" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 lg:py-20 grid gap-12 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3 mb-5">
          <LotusLogo size={48} testId="footer-logo-badge" />
          <div className="leading-tight">
            <p className="font-serif text-lg text-gold-400">Holistic Healing</p>
            <p className="text-[10px] uppercase tracking-[0.3em] text-cream-50/50">Psychotherapy, Inc.</p>
          </div>
        </div>
        <p className="text-sm leading-relaxed text-cream-50/60 max-w-xs">
          Experienced, compassionate therapy for couples and individuals across California — grounded in nearly 20 years of clinical practice.
        </p>
        <p className="text-sm text-gold-300/90 mt-3" data-testid="footer-spanish-note">Se habla español · Terapia en inglés y español</p>
      </div>
      <div>
        <p className="eyebrow mb-5">Explore</p>
        <ul className="space-y-3 text-sm">
          <li><Link className="hover:text-gold-400 transition-colors" to="/couples-therapy" data-testid="footer-link-couples">Couples Therapy</Link></li>
          <li><Link className="hover:text-gold-400 transition-colors" to="/couples-therapy-intensive" data-testid="footer-link-intensive">Couples Therapy Intensive</Link></li>
          <li><Link className="hover:text-gold-400 transition-colors" to="/infidelity-trust" data-testid="footer-link-infidelity">Infidelity & Rebuilding Trust</Link></li>
          <li><Link className="hover:text-gold-400 transition-colors" to="/post-relationship-counseling" data-testid="footer-link-post-relationship">Post-Relationship Counseling</Link></li>
          <li><Link className="hover:text-gold-400 transition-colors" to="/separation-counseling" data-testid="footer-link-separation">Separation & Post-Marital</Link></li>
          <li><Link className="hover:text-gold-400 transition-colors" to="/individual-therapy" data-testid="footer-link-individual">Individual Therapy</Link></li>
          <li><Link className="hover:text-gold-400 transition-colors" to="/my-approach" data-testid="footer-link-approach">My Approach</Link></li>
          <li><Link className="hover:text-gold-400 transition-colors" to="/about-me" data-testid="footer-link-about">About Me</Link></li>
          <li><Link className="hover:text-gold-400 transition-colors" to="/telehealth-faq" data-testid="footer-link-faq">Telehealth & FAQ</Link></li>
          <li><Link className="hover:text-gold-400 transition-colors" to="/blog" data-testid="footer-link-blog">Blog</Link></li>
          <li><Link className="hover:text-gold-400 transition-colors" to="/testimonials" data-testid="footer-link-testimonials">Testimonials</Link></li>
          <li><Link className="hover:text-gold-400 transition-colors" to="/es" data-testid="footer-link-espanol">En Español</Link></li>
        </ul>
      </div>
      <div>
        <p className="eyebrow mb-5">Begin the Conversation</p>
        <p className="text-sm mb-2" data-testid="footer-phone">Phone: <a href="tel:+16573339466" className="text-gold-300 hover:text-gold-400 transition-colors">(657) 333-9466</a></p>
        <p className="text-sm mb-2" data-testid="footer-email">Email: <a href="mailto:bqholistichealing@gmail.com" className="text-gold-300 hover:text-gold-400 transition-colors">bqholistichealing@gmail.com</a></p>
        <p className="text-sm mb-6" data-testid="footer-address">Office: 3711 Long Beach Blvd, Suite 645, Long Beach, CA 90807 (Saturdays only)</p>
        <p className="text-sm mb-6">
          <Link to="/card" className="text-gold-300 hover:text-gold-400 transition-colors underline underline-offset-4" data-testid="footer-business-card-link">Virtual Business Card</Link>
        </p>
        <Link
          to="/contact"
          data-testid="footer-schedule-cta"
          className="inline-flex items-center rounded-full bg-cream-50 text-forest-900 text-sm font-semibold px-6 py-3 transition-colors duration-300 hover:bg-white"
        >
          Schedule a Consultation
        </Link>
      </div>
    </div>
    <div className="border-t border-cream-50/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row gap-3 justify-between text-xs text-cream-50/40">
        <p>© {new Date().getFullYear()} Holistic Healing Psychotherapy, Inc. · California Licensed Clinical Social Worker</p>
        <p>Serving clients throughout California via secure telehealth · <Link to="/admin/login" className="hover:text-gold-400 transition-colors" data-testid="footer-admin-link">Admin</Link></p>
      </div>
    </div>
    <a
      href="https://wa.me/16573339466"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with the practice on WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-forest-800 text-gold-400 shadow-[0_10px_30px_rgba(18,55,42,0.35)] transition-all duration-300 hover:bg-forest-900 hover:scale-105"
    >
      <MessageCircle size={24} strokeWidth={1.8} />
    </a>
  </footer>
);

export default Footer;
